import { render, staticRenderFns } from "./basicsPage.vue?vue&type=template&id=ba24fc6e&scoped=true&"
import script from "./basicsPage.vue?vue&type=script&lang=js&"
export * from "./basicsPage.vue?vue&type=script&lang=js&"
import style0 from "./basicsPage.vue?vue&type=style&index=0&id=ba24fc6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba24fc6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba24fc6e')) {
      api.createRecord('ba24fc6e', component.options)
    } else {
      api.reload('ba24fc6e', component.options)
    }
    module.hot.accept("./basicsPage.vue?vue&type=template&id=ba24fc6e&scoped=true&", function () {
      api.rerender('ba24fc6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/basicsPage.vue"
export default component.exports